import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import PharmacyHero from './components/PharmacyHero';
import PharmacySidebar from './components/PharmacySidebar';
import PharmacyIntro from './components/PharmacyIntro';
import PharmacyBenefits from './components/PharmacyBenefits';
import PharmacyProcess from './components/PharmacyProcess';
import PharmacyWhyChoose from './components/PharmacyWhyChoose';
import PharmacyFAQ from './components/PharmacyFAQ';
import PharmacyCTABar from './components/PharmacyCTABar';
import { useSEO } from '../../utils/seo';

export default function PharmacyServices() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://thornhilltreatment.com';

  useSEO({
    title: 'Pharmacy Services Thornhill | Prescriptions, Compounding & Smoking Cessation',
    description:
      'Comprehensive pharmacy services in Thornhill including prescription dispensing, medication reviews, compounding, smoking cessation with Zonnic pouches, and free delivery. Expert pharmaceutical care serving Thornhill, North York, Richmond Hill, and Vaughan. Call (905) 709-9985.',
    keywords:
      'pharmacy services Thornhill, prescription dispensing, medication compounding, smoking cessation, Zonnic pouches, medication reviews, free delivery pharmacy',
    canonical: `${siteUrl}/pharmacy-services`,
    ogType: 'website',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Pharmacy',
      name: 'Thornhill Drug-Mart Pharmacy Services',
      description:
        'Comprehensive pharmacy services including prescription dispensing, medication reviews, compounding, smoking cessation programs, and free delivery in Thornhill, Ontario',
      url: `${siteUrl}/pharmacy-services`,
      telephone: '+1-905-709-9985',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '8108 Yonge St Unit 3-4',
        addressLocality: 'Thornhill',
        addressRegion: 'ON',
        postalCode: 'L4J 1W4',
        addressCountry: 'CA',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '43.8184',
        longitude: '-79.4278',
      },
    },
  });

  return (
    <div className="min-h-screen bg-[#f8f8f7]">
      <Navbar isScrolled={isScrolled} />

      {/* Hero Banner */}
      <PharmacyHero />

      {/* Main 2-column layout */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-14 items-start">

          {/* ── Left: Scrollable Main Content ── */}
          <main aria-label="Pharmacy services content" className="flex-1 min-w-0 w-full">
            <PharmacyIntro />
            <PharmacyBenefits />
            <PharmacyProcess />
            <PharmacyWhyChoose />
            <PharmacyFAQ />
          </main>

          {/* ── Right: Static Sticky Sidebar — desktop only ── */}
          <aside
            aria-label="Services sidebar"
            className="hidden lg:block sticky top-24 w-72 flex-shrink-0 space-y-6">
            <PharmacySidebar />
          </aside>

        </div>

        {/* Mobile sidebar — shown below main content on small screens */}
        <div className="lg:hidden mt-10">
          <PharmacySidebar />
        </div>
      </div>

      {/* Bottom CTA bar */}
      <PharmacyCTABar />

      <Footer />
    </div>
  );
}
